import { getAssignedCenterId } from "./userSession";

const CONTEXT_KEY = "context";

export const getStoredContext = () => {
    try {
        const raw = localStorage.getItem(CONTEXT_KEY);
        if (raw) {
            return JSON.parse(raw);
        }
    } catch {
        // ignore invalid JSON and fall back to legacy keys
    }

    return {
        fy: localStorage.getItem("selectedFY") || "",
        department: localStorage.getItem("selectedDepartment") || "",
        project: localStorage.getItem("selectedProjectId") || "",
        projectName: localStorage.getItem("selectedProjectName") || "",
        centerId: localStorage.getItem("selectedCenterId") || ""
    };
};

export const saveContext = ({ fy = "", department = "", project = "", projectName = "", centerId = "" }) => {
    const context = { fy, department, project, projectName, centerId };

    localStorage.setItem(CONTEXT_KEY, JSON.stringify(context));
    localStorage.setItem("selectedFY", fy);
    localStorage.setItem("selectedDepartment", department);
    localStorage.setItem("selectedProjectId", project);
    localStorage.setItem("selectedProjectName", projectName);

    if (centerId) {
        localStorage.setItem("selectedCenterId", centerId);
    } else {
        localStorage.removeItem("selectedCenterId");
    }

    return context;
};

export const clearContextStorage = () => {
    localStorage.removeItem(CONTEXT_KEY);
    localStorage.removeItem("selectedFY");
    localStorage.removeItem("selectedDepartment");
    localStorage.removeItem("selectedProjectId");
    localStorage.removeItem("selectedProjectName");
    localStorage.removeItem("selectedCenterId");
};

export const hasValidContext = () => {
    const context = getStoredContext();
    return Boolean(context?.centerId || getAssignedCenterId() || (context?.fy && context?.department && context?.project));
};
